
let initStore = {
    facetLoading: false,
    facetError: false,
    svflyfacet_myloc:{
        my_orgqueryText: "xx",
        my_dstqueryText: "yy",
        STARTDATE:"2025-11-25",
        ENDDATE: "2025-11-27",
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "Asia/Kolkata",
        
        
        esqueryChilds:"m0",
        esqueryInfants:"i0",
        esqueryAdults:"t1",
        esqueryCabin:"ECONOMY",
        svpageSize:5

    },
    facetData: {
        checkedFbParkingLabel:'American Airlines',
        checkedFbParking:true,
        disabledFbParking:false,

        minBudgetPrice:20,
        maxBudgetPrice:800,
        valueSlider:100,


        

        checkedAirline1Label:'Delta Airlines',
        checkedAirline1:true,
        disabledAirline1:false,

        checkedAirline2Label:'Alaska Airlines',
        checkedAirline2:true,
        disabledAirline2:false,

        checkedAirline3Label:'American Airlines',
        checkedAirline3:true,
        disabledAirline3:false,

        

        checkedAirline4Label:'Frontier Airlines',
        checkedAirline4:true,
        disabledAirline4:false,

        checkedAirline5Label:'Spirit Airlines',
        checkedAirline5:true,
        disabledAirline5:false,

        checkedSeat0Label:'Carry On Baggage',
        checkedSeat0:true,
        disabledSeat0:false,

        checkedSeat1Label:'Seat Selection',
        checkedSeat1:true,
        disabledSeat1:false,

        checkedTake0Label:'Early Morning',
        checkedTake0:true,
        disabledTake0:false,

        checkedTake1Label:'Morning',
        checkedTake1:true,
        disabledTake1:false,

        checkedTake2Label:'Afternoon',
        checkedTake2:true,
        disabledTake2:false,

        checkedTake3Label:'Evening',
        checkedTake3:true,
        disabledTake3:false,

        checkedLand0Label:'Early Morning',
        checkedLand0:true,
        disabledLand0:false,

        checkedLand1Label:'Morning',
        checkedLand1:true,
        disabledLand1:false,

        checkedLand2Label:'Afternoon',
        checkedLand2:true,
        disabledLand2:false,

        checkedLand3Label:'Evening',
        checkedLand3:true,
        disabledLand3:false,
       


        checkedStop0Label:'Non Stop',
        checkedStop0:true,
        disabledStop0:false,
        
        checkedStop1Label:'1 or More Stops',
        checkedStop1:true,
        disabledStop1:false,
        
        checkedAirline6Label:'United Airlines',
        checkedAirline6:true,
        disabledAirline6:false,

        checkedAirline7Label:'AS Airlines',
        checkedAirline7:true,
        disabledAirline7:false,

        checkedAirline8Label:'SY Airlines',
        checkedAirline8:true,
        disabledAirline8:false
    }
}


export default (store = initStore, action) => {

    console.log(action);

    switch (action.type) {
        case "facet/FLIGHTS_LIST":
            console.log('tasks FLIGHTS_LIST reducer')
            return { ...store, facetData: action.payload.facetData, facetLoading: false, facetError: null }
        case "facet/FLIGHTS_BEGIN":
        
            return { ...store, facetData: [], facetLoading: true, facetError: null }
        case "facet/FLIGHTS_ERROR":
            return { ...store, facetData: [], facetError: action.error, facetLoading: false }
        case  "facet/FLIGHTS_SUCCESS":
            if(action.payload.svflyfacet_myloc){
                return { ...store, svflyfacet_myloc:action.payload.svflyfacet_myloc,facetData: action.payload.facetData, facetLoading: false}
 
            }else{
                return { ...store, facetData: action.payload.facetData, facetLoading: false}
 
            }
                
        default:
            return store
    }
}